import clients from 'img/vigbo/empty-sale/clients.png';
import profession from 'img/vigbo/empty-sale/profession.png';
import twoSubs from 'img/vigbo/empty-sale/two-subs.png';
import type { BenefitCardProps } from 'reactApp/ui/EmptyVigboFeaturesPreview/BenefitCard/BenefitCard';

export const VIGBO_BENEFITS: BenefitCardProps[] = [
    {
        iconSrc: clients,
        text: 'Галереи для передачи съёмок клиентам',
    },
    {
        iconSrc: profession,
        text: 'Профессиональные инструменты в Vigbo для фотографов',
    },
    {
        iconSrc: twoSubs,
        text: 'Одна подписка сразу на два сервиса для работы',
    },
];
